
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/rwg-bridge/forgot-password",
      function () {
        return require("private-next-pages/rwg-bridge/forgot-password.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/rwg-bridge/forgot-password"])
      });
    }
  